import { useEffect, useState } from "react";
import axios from "axios";
import { Quote, Star } from "lucide-react";
import Reveal from "../components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Testimonials() {
  const [list, setList] = useState([]);
  useEffect(() => {
    axios.get(`${API}/testimonials`).then((r) => setList(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <section className="pt-40 md:pt-48 pb-16 container-luxe">
        <div className="eyebrow mb-6">Guest Letters</div>
        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-balance max-w-5xl">
          The voices of those<br /><span className="italic">we have hosted</span>.
        </h1>
        <p className="mt-8 text-foreground/70 max-w-2xl leading-relaxed">
          Read in our guests' own words. We publish every letter received — gently edited for length, never for content.
        </p>
      </section>

      <section className="pb-24 container-luxe">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {list.map((t, i) => (
            <Reveal key={t.id} delay={i * 80}>
              <article data-testid={`testimonial-${t.id}`} className="h-full bg-secondary/40 border border-border p-10 md:p-14 flex flex-col">
                <Quote size={32} strokeWidth={1} className="text-accent mb-8" />
                <div className="flex items-center gap-1 mb-6">
                  {Array.from({ length: t.rating }).map((_, k) => (
                    <Star key={k} size={14} fill="currentColor" strokeWidth={0} className="text-accent" />
                  ))}
                </div>
                <p className="font-serif text-2xl md:text-3xl leading-snug text-foreground/90 flex-1">
                  "{t.quote}"
                </p>
                <div className="mt-10 flex items-center gap-4 pt-6 border-t border-border">
                  <img src={t.avatar} alt={t.name} className="h-14 w-14 rounded-full object-cover" />
                  <div>
                    <div className="font-serif text-xl">{t.name}</div>
                    <div className="text-[11px] uppercase tracking-[0.2em] text-foreground/50 mt-1">{t.journey} · {t.location}</div>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
